import React, { createContext, useState, useContext, useEffect } from 'react';
import { createCheckout } from '../fourthwall';

// 1. Point to your Backend that returns EVERYTHING
const BACKEND_URL = 'https://vntg-api.onrender.com/api/products/all';

const ShopContext = createContext();

export const useShop = () => useContext(ShopContext);

export const ShopProvider = ({ children }) => {
  const [currency, setCurrency] = useState('USD');
  const [cart, setCart] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  
  // THE MEGA CACHE
  const [productsList, setProductsList] = useState([]); 
  const [isLoaded, setIsLoaded] = useState(false);

  // 2. FETCH EVERYTHING ON LOAD (ONCE)
  useEffect(() => {
    const fetchAll = async () => {
      try {
        const response = await fetch(BACKEND_URL);
        const data = await response.json();
        
        // CHECK: Ensure data is actually an array before using it
        if (Array.isArray(data)) {
          // Sort by date (optional)
          data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
          setProductsList(data);
        } else {
          console.error("API returned invalid data format:", data);
          setProductsList([]); // Fallback to empty list
        }
        
      } catch (e) {
        console.error("Mega-Fetch failed:", e);
        setProductsList([]); // Fallback to empty list
      } finally {
        setIsLoaded(true);
      }
    };
    fetchAll();
  }, []);

  // 3. Helper to find a product in our local cache
  const getProductFromCache = (slug) => {
    return productsList.find(p => p.slug === slug) || null;
  };

  const addToCart = (product, qty = 1) => {
    const itemToAdd = {
      ...product,
      variantId: product.variantId || product.defaultVariantId, 
      quantity: qty 
    };
    const existing = cart.find(item => item.variantId === itemToAdd.variantId);
    if (existing) {
      setCart(cart.map(item => item.variantId === itemToAdd.variantId ? { ...item, quantity: item.quantity + qty } : item));
    } else {
      setCart([...cart, itemToAdd]);
    }
    setIsCartOpen(true);
  };

  const removeFromCart = (variantId) => {
    setCart(cart.filter(item => item.variantId !== variantId));
  };

  return (
    <ShopContext.Provider value={{
      currency, setCurrency,
      cart, addToCart, removeFromCart,
      isCartOpen, setIsCartOpen,
      productsList, isLoaded, getProductFromCache
    }}>
      {children}
    </ShopContext.Provider>
  );
};